import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderArrowUpOutline = createIcon({
  displayName: 'FolderArrowUpOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <line
        x1="12"
        y1="19.99999"
        x2="12"
        y2="13.99999"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <polyline
        points="14 16 12 14 10 16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16,20h3a1.99945,1.99945,0,0,0,2-2V8.94a2.00009,2.00009,0,0,0-2-2H12.529a.99981.99981,0,0,1-.827-.438L10.297,4.437A.99961.99961,0,0,0,9.471,4H5A1.99945,1.99945,0,0,0,3,6V18a1.99945,1.99945,0,0,0,2,2H8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const FolderArrowUp: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderArrowUpTwoTone} {...props} />

  return <CustomIcon as={FolderArrowUpOutline} {...props} />
}

export default memo(FolderArrowUp)
